import { useFragment } from 'react-relay';
import { addressFragment } from './Address.relay';
import type { AddressPropsType } from './types';

export const Address: React.FC<AddressPropsType> = (props) => {
  const address = useFragment(addressFragment, props.address);

  return (
    <address className="text-right font-serif text-xl [&>div]:border-t [&>div]:border-b [&>div]:border-[#e2e2e2] [&>div]:py-5 [&_h2]:text-[40px] [&_h2]:leading-10 [&_h2]:text-accent [&_h2]:mb-2.5 [&_a]:text-accent [&_a]:no-underline [&_a:hover]:text-accent max-[700px]:mb-[35px] max-[700px]:text-center max-[700px]:[&_h2]:text-[32px] min-[701px]:max-[1100px]:w-full min-[701px]:max-[1100px]:text-center">
      <div>
        <h2>{address.companyName}</h2>
        {address.street}
        <br />
        {address.postCode} {address.city}
        <br />
        {address.country}
        <br />
        {props.phoneLabel} <a href={`tel:${address.phone}`}>{address.phone}</a>
        <br />
        {props.faxLabel} {address.fax}
        <br />
        {props.emailLabel} <a href={`mailto:${address.email}`}>{address.email}</a>
        <br />
      </div>
    </address>
  );
};
